"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.function.name");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

/**
* A class to represent the the options that are passed to the MwChartHeatmapOptions.tooltipFormatter
* @package
*
* @param {object} options - See below
* @param {object} options.point - The 'Point' object from Highcharts
*
* @property {string} key - Key name of the point triggering the tooltip
* @property {number} keyIndex - Key index of the point triggering the tooltip
* @property {number} seriesIndex - The index of the series in the provided chart data
* @property {string} seriesName - The name of the series
* @property {number} value - The value of the point
*/
var MwChartHeatmapTooltipOptions = function MwChartHeatmapTooltipOptions(_ref) {
  var point = _ref.point;
  (0, _classCallCheck2.default)(this, MwChartHeatmapTooltipOptions);
  this.key = point.name;
  this.keyIndex = point.x;
  this.seriesIndex = point.y;
  this.seriesName = point.series.yAxis.categories[point.y];
  this.value = point.value;
  Object.freeze(this);
};

exports.default = MwChartHeatmapTooltipOptions;